import gql from 'graphql-tag';

export const GOOGLE_DRIVE_FILE_LINK_METADATA_FRAGMENT = gql`
  fragment googleDriveFileLinkMetadata on GoogleDriveFileLinkMetadata {
    fileMetadata {
      title
      extension
    }
  }
`;
